export const CustomerDiscountValidation = (formData) => {
    const errors = {};
    debugger;
    if (formData.FK_StockCategory_ID > 0) {
       /* if (formData.FK_DiscountType_ID == "0") {
            errors.FK_DiscountType_ID = 'This field is required';
        }*/
    }


    return errors;
};
